module.exports = __webpack_public_path__ + "assets/img/house-1.88056fce.png";